<div class="modal-header-contratante">
  <button class="btn-close-modal" (click)="continuar(false)">✕</button>
  <span>Información Contratante</span>
</div>
<div class="col-md-12">
  <div *ngIf="opciones == true" class="modal-dialog-header-b">
    <div class="container">
      <div class="row p-0 m-0 mt-2">
        <div class="col-md-12" style="padding-top: 10px">
          <mat-label style="color: #0372b9">Tipo de documento *</mat-label>
          <mat-form-field class="" style="color: white" appearance="outline">
            <mat-select [(ngModel)]="selectedTipoDocumento" placeholder="Seleccionar">
              <mat-option value="">Seleccionar</mat-option>
              <mat-option *ngFor="let doc of typeDocument" [value]="doc.codigo">
                {{ doc.codigo }} - {{ doc.tipo_documento.toUpperCase() }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>
      <div class="row p-0 m-0 mt-2">
        <div class="col-md-12">
          <mat-label style="color: #0372b9">Numero de documento *</mat-label>
          <mat-form-field appearance="outline">
            <input
              (keyup.enter)="buscarPersona()"
              (input)="filtrarDocumento($event)"
              [(ngModel)]="documento"
              matInput
              #message
              minlength="7"
              maxlength="30"
              inputmode="text"
            />
            <mat-icon (click)="buscarPersona()" matSuffix>search</mat-icon>
            <mat-hint align="start"><strong></strong> </mat-hint>
            <mat-hint align="end">{{ message.value.length }} / 30</mat-hint>
          </mat-form-field>
        </div>
      </div>
    </div>
  </div>
  <div
    class="modal-dialog-body-b"
    [ngClass]="{
      'modal-1-contrato': listContrato.length === 1,
      'modal-multi-contrato': listContrato.length > 1
    }"
  >
    <div class="container">
      <br />
      <!-- <div class="row">
                <div class="col-md-12" style=" padding: 0px 20px 0px 20px;">
                    <p style="text-align: center;color: #0372b9; font-weight: 600 !important;">Usuario se encuentra activo en los siguientes contratos
                        con COOMEVA MP</p>
                </div>
            </div> -->
      <div>
        <div
          *ngIf="listContrato.length > 0 && opcionesNew"
          class="panelContract"
        >
          <div class="col-md-12" style="padding: 0px 20px 0px 20px">
            <p
              style="
                text-align: center;
                color: #000000;
                font-weight: 800 !important;
              "
            >
              El usuario se encuentra activo en los siguientes contratos con
              COOMEVA MP
            </p>
          </div>
          <div *ngFor="let item of listContrato" class="mb-2">
            <div
              *ngIf="opciones == true"
              class="contrato-row"
              [ngClass]="{ 'contrato-bloqueado': isItemDisabled(item) }">
              <div class="radio-col">
              <input type="checkbox" [id]="item.contra" [checked]="isItemSelected(item)" [disabled]="isItemDisabled(item)" (change)="onToggleContrato(item, $event)" />
              </div>

              <!-- Contenido en 6 columnas x 2 filas -->
              <div class="info-grid">
                <div class="campo">
                  <strong>Número de Contrato</strong>
                  <div>{{ item.contra }}</div>
                </div>

                <div class="campo">
                  <strong>Línea</strong>
                  <div>{{ homologar(item.Linea_Negocio, "linea") }}</div>
                </div>

                <div class="campo">
                  <strong>Plan</strong>
                  <div>{{ homologar(item.Cuenta, "plan") }}</div>
                </div>

                <div class="campo">
                  <strong>Programa</strong>
                  <div>{{ homologar(item.cod_programa_afi, "programa") }}</div>
                </div>

                <div class="campo">
                  <strong>Estado de mora</strong>
                  <div [ngClass]="{'mora-roja': item.mora === 'EN MORA'}">
                    {{ item.mora === 'EN MORA' ? 'SI' : 'NO' }}
                  </div>
                </div>

                <div class="campo asesor-col">
                  <strong>Asesor población</strong>
                  <div>{{ item.nombreAsesor }}</div>
                </div>
              </div>
            </div>

            <div *ngIf="opciones == false">
              <div class="row">
                <div class="col text-center text-light">No. de contrato:</div>
                <div class="col text-light">{{ item.contra }}</div>
              </div>
              <div class="row">
                <div class="col text-center text-light">Línea:</div>
                <div class="col text-light">
                  {{ homologar(item.Linea_Negocio, "linea") }}
                </div>
              </div>
              <div class="row">
                <div class="col text-center text-light">Plan:</div>
                <div class="col text-light">
                  {{ homologar(item.Cuenta, "plan") }}
                </div>
              </div>
              <div class="row">
                <div class="col text-center text-light">Programa:</div>
                <div class="col text-light">
                  {{ homologar(item.cod_programa_afi, "programa") }}
                </div>
              </div>
              <div class="row">
                <div class="col text-center text-light">Mora:</div>
                <div class="col text-light">
                  {{ homologar(item.mora, "mora") }}
                </div>
              </div>
              <div class="row">
                <div class="col text-center text-light">Asesor:</div>
                <div class="col text-light">
                  {{ homologar(item.nombreAsesorPoblacion, "nombreAsesorPoblacion") }}
                </div>
              </div>
              <div class="row">
                <div class="col text-center"></div>
                <div class="col"><br /></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-dialog-footer-b">
    <div
      *ngIf="listContrato.length > 0 && opciones == true"
      class="modal-dialog-button"
      style="background-color: #0372b9; color: #fff"
      (click)="continuar(true)"
    >
      Aceptar
    </div>
    <div
      class="modal-dialog-button"
      style="background-color: #0372b9; color: #fff"
      (click)="continuar(false)"
    >
      Cerrar
    </div>
  </div>
</div>
